import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Col, InputNumber, Row, Table } from "antd";

const ProductPrice = ({
  sellerList,
  orderInfo,
  setOrderInfo,
  selectedOptionRows,
  setSelectedOptionRows,
  selectedOptionRowKeys,
  setSelectedOptionRowKeys,
  discountRate,
  setDiscountRate,
  discountAmount,
  setDiscountAmount,
}) => {
  const isLoading = useSelector((state) => state.common.loading);
  const [selectSeller, setSelectSeller] = useState([]);
  const [productBySeller, setProductBySeller] = useState([]);
  const [deliveryBySeller, setDeliveryBySeller] = useState([]);

  useEffect(() => {
    setDiscountRate(0);
    setDiscountAmount(0);
  }, [selectedOptionRows]);

  const columns = [
    {
      title: "브랜드명",
      width: 100,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
    },
    {
      title: "상품명",
      width: 150,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "옵션명",
      width: 150,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
      render: (value) => (
        <p
          style={{
            width: "150px",
            fontSize: "1em",
            margin: 0,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          {value}
        </p>
      ),
    },
    {
      title: "가격",
      width: 150,
      dataIndex: "price_2",
      key: "price_2",
      ellipsis: true,
      render: (value, record) => (value * record?.quantity)?.toLocaleString(),
    },
    {
      title: "수량",
      width: 150,
      // dataIndex: 'option_benefit',
      // key: 'option_benefit',
      ellipsis: true,
      fixed: "right",
      align: "center",
      render: (value, record, index) => {
        return (
          <div>
            <Button
              id="minus"
              onClick={(e) => changeProductQuantity(e, "minus", value, index)}
              size={`small`}
            >
              -
            </Button>
            <Button size={`small`}>
              {value.quantity ? value.quantity : 1}
            </Button>
            <Button
              id="plus"
              onClick={(e) => changeProductQuantity(e, "plus", value, index)}
              size={`small`}
            >
              +
            </Button>
          </div>
        );
      },
    },
    {
      title: "삭제",
      key: "operation",
      width: 100,
      fixed: "right",
      align: "center",
      render: (value, record, index) => (
        <img
          src={`${process.env.REACT_APP_HOST}/assets/images/memberManage/delete.png`}
          className={`delete-button`}
          alt={"닫기 버튼"}
          onClick={() => deleteCartOption(value, record, index)}
          style={{
            width: "1.2em",
            height: "1.2em",
          }}
        />
      ),
    },
  ];

  /**
   * 구매할 옵션 삭제하기
   * @param value
   * @param record
   * @param index
   */
  const deleteCartOption = (value, record, index) => {
    let list = [...selectedOptionRows];
    let keyList = [...selectedOptionRowKeys];
    list.splice(index, 1);
    keyList.splice(index, 1);
    setSelectedOptionRows(list);
    setSelectedOptionRowKeys(keyList);
  };

  /**
   * 주문 결제 상품 - 수량 변경
   */
  const changeProductQuantity = (e, method, value, index) => {
    e.stopPropagation();
    let currList = [...selectedOptionRows];
    let target = { ...value };
    if (method === "plus") {
      target.quantity += 1;
    } else {
      if (target?.quantity > 1) {
        target.quantity -= 1;
      }
    }
    currList[index] = target;
    setSelectedOptionRows(currList);
  };

  /**
   * 할인율 적용
   */
  const applyDiscount = () => {
    if (discountRate > 0) {
      const originalTotal = orderInfo?.total_price;
      const discountAmount = Math.floor((originalTotal * discountRate) / 100);
      // 10원 단위
      const roundedDiscountAmount = Math.floor(discountAmount / 10) * 10;
      setDiscountAmount(roundedDiscountAmount);
    } else {
      setDiscountAmount(0);
    }
  };

  useEffect(() => {
    if (selectedOptionRows?.length) {
      let priceList = selectedOptionRows.map(
        (item) => item.price_2 * item.quantity,
      );
      let totalPrice = priceList.reduce((a, b) => a + b, 0);
      setOrderInfo({
        ...orderInfo,
        total_price: totalPrice,
      });

      let sellers = selectedOptionRows.map((item) => ({
        ...sellerList.filter(
          (seller) => item.seller_id === seller.seller_id,
        )?.[0],
      }));
      setSelectSeller(sellers);
    } else {
      setOrderInfo({
        ...orderInfo,
        total_price: 0,
      });
      setSelectSeller([]);
    }
  }, [selectedOptionRows]);

  useEffect(() => {
    let list = [];
    for (let i = 0; i < selectSeller?.length; i++) {
      let obj = {
        seller_id: null,
        seller_name: null,
        selectList: [],
      };
      // 판매자 별로 다시 묶기
      let filter = selectedOptionRows.filter(
        (item) => item.seller_id === selectSeller[i].seller_id,
      );
      obj.seller_id = selectSeller[i].seller_id;
      obj.seller_name = selectSeller[i].seller_name;
      obj.delivery_price = selectSeller[i].delivery_price;
      obj.delivery_price_baseline = selectSeller[i].delivery_price_baseline;
      obj.selectList = filter;
      list.push(obj);
    }
    // 판매자 중복 제거
    if (list?.length) {
      const filteredList = list.reduce((prev, curr) => {
        const findData = prev.find((item) => item.seller_id === curr.seller_id);
        if (!findData) {
          return prev.concat([curr]);
        } else {
          return prev;
        }
      }, []);
      setProductBySeller(filteredList);
    } else {
      setProductBySeller([]);
    }
  }, [selectSeller]);

  useEffect(() => {
    if (productBySeller?.length) {
      let list = [];
      for (let i = 0; i < productBySeller?.length; i++) {
        let obj = {};
        let selectList = productBySeller[i]?.selectList;
        let total_price = 0;
        for (const item of selectList) {
          total_price += item.price_2 * item.quantity;
        }

        obj.seller_id = productBySeller[i].seller_id;
        obj.seller_name = productBySeller[i].seller_name;
        obj.delivery_price_baseline =
          productBySeller[i].delivery_price_baseline;
        obj.total_price = total_price;
        if (total_price >= productBySeller[i].delivery_price_baseline) {
          obj.delivery_price = 0;
        } else {
          obj.delivery_price = productBySeller[i].delivery_price;
        }

        list.push(obj);
      }
      setDeliveryBySeller(list);
    } else {
      setDeliveryBySeller([]);
    }
  }, [productBySeller]);

  useEffect(() => {
    setOrderInfo({
      ...orderInfo,
      delivery_price: deliveryBySeller
        ?.map((d) => d.delivery_price)
        ?.reduce((a, b) => a + b, 0),
    });
  }, [deliveryBySeller]);

  return (
    <>
      <div
        className={`order-component-each-detail`}
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "10px",
        }}
      >
        <h4 className={`order-each-detail-title`}>장바구니</h4>
        <Table
          className="order-create-product-list-table order-create-product-option-list-table"
          columns={columns}
          dataSource={selectedOptionRows}
          loading={isLoading}
          bordered
          size="middle"
          rowKey="id"
          rowClassName="coupon-table-row"
          scroll={{ x: true }}
          pagination={false}
        />
      </div>

      {/* 배송비 */}
      <div className={`order-component-each`}>
        <h3 className={`order-each-title`}>
          배송비
          <span className="title-required">*</span>
        </h3>
        <Col className={`order-component-each-col`}>
          <div className={`order-component-each-detail`}>
            <Row
              align="top"
              justify={"space-between"}
              style={{ rowGap: "3px" }}
            >
              <Col>
                <div
                  className={`delivery-price-div`}
                  style={{
                    flexDirection: "column",
                    marginBottom: "5px",
                  }}
                >
                  {deliveryBySeller?.map((item, idx) => (
                    <div
                      key={`delivery-by-seller-${idx}`}
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ color: "#adb5bd", fontSize: "0.8rem" }}>
                        {item?.seller_name} :
                      </p>
                      <p>{item?.delivery_price?.toLocaleString()}원</p>
                      {!!item?.delivery_price && (
                        <p style={{ color: "#adb5bd", fontSize: "0.8rem" }}>
                          ({item?.delivery_price_baseline?.toLocaleString()}원
                          이상 구매 시 무료배송)
                        </p>
                      )}
                    </div>
                  ))}
                  <p
                    style={{
                      fontSize: "1em",
                      fontWeight: 600,
                    }}
                  >
                    총 배송비 :{" "}
                    {deliveryBySeller
                      ?.map((d) => d.delivery_price)
                      ?.reduce((a, b) => a + b, 0)
                      ?.toLocaleString()}
                    원
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </div>

      {/* 할인율 */}
      <div className={`order-component-each`}>
        <h3 className={`order-each-title`}>할인율</h3>
        <Col className={`order-component-each-col`}>
          <div className={`order-component-each-detail`}>
            <Row
              align="middle"
              justify={"space-between"}
              style={{ rowGap: "3px" }}
            >
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <InputNumber
                    min={0}
                    max={100}
                    placeholder="할인율 입력"
                    value={discountRate}
                    onChange={(value) => setDiscountRate(value || 0)}
                    onPressEnter={applyDiscount}
                    size="small"
                    style={{
                      width: 80,
                      margin: 0,
                      lineHeight: "32px",
                      verticalAlign: "middle",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  />
                  <Button
                    type="primary"
                    onClick={applyDiscount}
                    disabled={discountRate <= 0}
                    size="small"
                  >
                    확인
                  </Button>
                  {discountAmount > 0 && (
                    <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                      할인 금액: {discountAmount.toLocaleString()}원
                    </span>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </div>

      {/* 총 금액 */}
      <div className={`order-component-each`}>
        <h3 className={`order-each-title`}>
          총 금액
          <span className="title-required">*</span>
        </h3>
        <Col className={`order-component-each-col`}>
          <div className={`order-component-each-detail`}>
            <Row
              align="top"
              justify={"space-between"}
              style={{ rowGap: "3px" }}
            >
              <Col>
                <div
                  className={`delivery-price-div`}
                  style={{
                    alignItems: "center",
                  }}
                >
                  <p>
                    <b>
                      {(
                        orderInfo?.total_price +
                        orderInfo?.delivery_price -
                        discountAmount
                      )?.toLocaleString()}
                      원
                    </b>
                  </p>
                  <p
                    style={{
                      fontSize: "1em",
                    }}
                  >
                    ({orderInfo?.total_price?.toLocaleString()}원 +{" "}
                    {orderInfo?.delivery_price?.toLocaleString()}원 -{" "}
                    {discountAmount?.toLocaleString()}원)
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </div>
    </>
  );
};
export default ProductPrice;
